import { CHAT_BOT, MOBILE_TOGGLE_SIDEBAR, TOGGLE_SIDEBAR } from '../types/header';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});

export const toggleMobileSidebar = () => ({ type: MOBILE_TOGGLE_SIDEBAR });

export const chatOpen = (payload: boolean) => ({ type: CHAT_BOT, payload });
